import React from "react";

const BuySection = () => {
  return (
    <>
      <h2 className="text-3xl font-bold mb-6">Gift Cards</h2>
      <p className="text-textGray">
        Treat yourself or a friend with a Willomina Gift Card. Valid for future
        visits!
      </p>
      <button className="mt-4 px-6 py-2 bg-black text-white rounded hover:bg-gray-800 transition">
        Buy Now
      </button>
    </>
  );
};

export default BuySection;
